// src/components/QRGenerator/QRGenerator.tsx
import React, { useEffect, useState } from 'react'
import { Button, Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import QRCode from 'qrcode.react'
import './QRGenerator.scss'

interface QRCodeGeneratorProps {
  url: string
  showModal: boolean
  onClose: () => void
}

const QRGenerator: React.FC<QRCodeGeneratorProps> = ({
  url,
  showModal,
  onClose
}) => {
  const [qrCodeUrl, setQrCodeUrl] = useState<string | null>(null)
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    if (url) {
      setQrCodeUrl(url)
    }
  }, [url])

  const handleDownloadQRCode = () => {
    if (!qrCodeUrl) return
    const canvas = document.getElementById('qrcode') as HTMLCanvasElement
    if (canvas) {
      setLoading(true)
      const pngUrl = canvas.toDataURL('image/png')
      const link = document.createElement('a')
      link.href = pngUrl
      link.download = 'qrcode.png'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      setLoading(false)
    } else {
      toast.error('Error al descargar el código QR')
    }
  }

  return (
    <Modal show={showModal} onHide={onClose} centered>
      <Modal.Header>
        <Modal.Title>Generador de QR</Modal.Title>
      </Modal.Header>

      <Modal.Body className="qr-code-generator">
        {qrCodeUrl ? (
          <div className="qr-container">
            <QRCode
              id="qrcode"
              value={qrCodeUrl}
              size={240}
              level="H"
              includeMargin
            />
          </div>
        ) : (
          <p className="no-url">No hay URL disponible</p>
        )}
      </Modal.Body>

      <Modal.Footer>
      <div className="form-modal-footer-custom"> 
        <Button variant="none" onClick={onClose} className='form-button-cancel'>
          Cerrar
        </Button>
        <Button
          variant="none"
          className='form-button-create'
          onClick={handleDownloadQRCode}
          disabled={loading || !qrCodeUrl}
        >
          {loading ? 'Generando...' : 'Descargar QR'}
        </Button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export default QRGenerator
